module.exports = __webpack_public_path__ + "static/media/favorite-scheduler.78cf7fc2.svg";